import Slider from 'react-slick';

import { Box, useTheme, useMediaQuery } from '@mui/material';

import './slick-theme.min.css';
import './slick.min.css';
import { marketingImageBox, marketingImageBoxMobile } from './styles';

const settings = {
  dots: true,
  arrows: true,
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
  speed: 750,
  autoplaySpeed: 5000,
  cssEase: 'linear',
  pauseOnHover: true,
};

export default function Carousel() {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('md'));
  const isDark = theme.palette.mode === 'dark';

  // Dynamically selects light or dark backgrounds based on theme state
  const imageSuffix = isDark ? '_dark' : '';

  return (
    <Box
      sx={{
        width: '100%',
        position: 'relative',
        '& .slick-prev, & .slick-next': {
          top: 'auto',
          bottom: '25px',
          transform: 'none',
          zIndex: 10,
          width: '30px',
          height: '30px',
        },
        '& .slick-prev': {
          left: '25px',
        },
        '& .slick-next': {
          right: '25px',
        },
      }}
    >
      <Slider {...settings} style={{ borderRadius: '50px' }}>
        {[1, 2, 3].map((im, key) => (
          <Box
            key={key}
            sx={
              isSmallScreen
                ? {
                    ...marketingImageBoxMobile,
                    backgroundImage: `url('assets/images/covers/cover_${im}${imageSuffix}.webp')`,
                  }
                : {
                    ...marketingImageBox,
                    backgroundImage: `url('assets/images/covers/cover_${im}${imageSuffix}.webp')`,
                  }
            }
          />
        ))}
      </Slider>
    </Box>
  );
}
